// Single source of truth for the Check-Up destination.
// When the Lovable app is finished, replace "/apply" with its URL —
// every check-up CTA on the site will follow automatically.
export const CHECKUP_URL = "/apply";
